import { Divider, Header, Icon, Loader, Message, Segment } from 'semantic-ui-react'
import { PosBrandPlatforms } from './PosBrandPlatforms'
import { useQuery } from '@tanstack/react-query'
import { getBrandsOfAPos } from '../../../services/PointOfSale/PointOfSale.service'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useUser from '../../Shared/UserProvider/useUser'

const POSBrands = ({ posId }) => {
    const [t] = useTranslation()

    const {user} = useUser();

    const { data: posBrands } = useQuery({
        queryFn: () => getBrandsOfAPos(posId),
        queryKey: ['pointofsales', posId, 'brands'],
        enabled: !!posId,
    })

    if (!posBrands) {
        return <Loader active />
    }

    if (posBrands.length === 0) {
        return (
          <Segment placeholder>
              <Header icon>
                  <Icon name="search" />
                  {t('administration.platforms.no_brands_configured_for_this_pos')}
              </Header>
          </Segment>
        )
    }

    const displayFranprixWarning = user?.companyId === '92b73161-e6ab-4581-b603-63bbe27b6c55'


    return (
      <>
       {displayFranprixWarning && (
            <Message info icon color="blue" >
                <Icon name="info circle"/>

                <Message.Content>
                                    <div>Attention : les prix du catalogue Marketplace Franprix sont déjà majorés.</div>
                                    <div>Les prix du catalogue sont actualisés chaque mois afin d’assurer la compétitivité de votre point de vente et préserver votre marge sur les marketplaces.</div>
                </Message.Content>
            </Message>)
        }
          {posBrands.map(brand => (
            <div key={`${posId}-${brand.id}`}>
                <Divider horizontal>{brand.name}</Divider>
                <PosBrandPlatforms posId={posId} brandId={brand.id} />
            </div>
          ))}
      </>
    )
}

export { POSBrands }
